export default "__VITE_ASSET__Di$DcfWX__"